import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { Subject } from 'rxjs';
import { CommonModulesForCountriesComponent } from '../commonModulesForCountries/common-modules-for-countries/common-modules-for-countries.component';
import { BackendApiService } from '../service/backendapi.service';
import { EndpointsService } from '../service/endpoints.service';
import { AddBussinessRulesComponent } from './add-bussiness-rules/add-bussiness-rules.component';

@Component({
  selector: 'app-business-rules',
  templateUrl: './business-rules.component.html',
  styleUrls: ['./business-rules.component.scss']
})
export class BusinessRulesComponent implements OnInit {

  @ViewChild(CommonModulesForCountriesComponent, { static: false }) commonCountryCompnent: CommonModulesForCountriesComponent;

  businessForm: FormGroup;
  closeResult: string;
  //multy select items
  homeNetworkList = [];
  homeNetworkSelectedItems = [];
  dropdownSettings = {};
  visitingNetworkList = [];
  visitingNetworkSelectedItems = [];
  tarrifList = [];
  tarrifSelectedItems = [];
  // tableData = [];
  isBusinessFormEdit = false;
  isBusinessFormView = true;
  editIndex = null;
  checkMOC = false;
  checkMTC = false;
  checkSMSMO = false;
  checkGPRS = false;
  checkDataOthers = false;
  isDisabled: boolean;
  disabled = "";
  businessData: [];
  businessData1: [];
  businessData2: [];
  businessData3: [];
  businessData4: [];
  unique: any = [];
  roleDataList: any = [];
  selectedTarriffData: [];
  mocData: any;
  SMSData: any;
  gprsData: any;
  mtcData: any;
  othersData: any;
  callVPMNNetwork: boolean;
  showTable: boolean;
  selectedNetwork: any = [];
  networkMultiSelectAction: boolean;
  globalNetworkSelected: string = '';
  alreadyselectedNetwork: any = [];
  public mode: string;
  tarrifData: [];
  numb: any;

  errorMessage: string;


  // created by harish

  vpmnCountry = 'All';
  vpmnNetwork = 'All';
  communityValue: any;
  isSuperUser: boolean;

  constructor(private spinnerService: Ng4LoadingSpinnerService,
    private router: Router, private endpointsService: EndpointsService,
    private backendApiService: BackendApiService, private dialog: MatDialog,
  ) { }

  open() {
    const dialogRef = this.dialog.open(AddBussinessRulesComponent, {
      height: '750px',
      panelClass: 'custom-modalbox',
      data: { type: 'Creation' },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed : ' + result);
    });
  }

  ngOnInit() {
    this.isSuperUser = Boolean(sessionStorage.getItem("isSuperUser")==="true");
  }

  reset() {
    this.businessForm.reset();
    this.homeNetworkSelectedItems = [];
    this.visitingNetworkSelectedItems = [];
    this.tarrifSelectedItems = [];
  }


  deleteRecord(index) {
    // this.tableData.splice(index, 1);
    // this.setData(this.tableData);
  }

  update(item: any) {
  }

  selectEvent($event: any, type) {
    if (type === 'Network_Name') {
      this.networkMultiSelectAction = true;
      this.selectedNetwork.push($event.itemData);
    }
  }

  removeEvent($event: any, type) {
    if (type === 'Network_Name') {
      this.networkMultiSelectAction = true;
      this.deleteItem($event.itemData, this.selectedNetwork);
    }

  }

  deleteItem(val, arr: any[]) {
    const index = arr.indexOf(val);
    if (index !== -1) {
      arr.splice(index, 1);
    }
  }

  closeNetworkNameMultiSelect() {
    let networkSelected = '';
    this.selectedNetwork.filter(val => {
      networkSelected = networkSelected + val.country + ',';
    });
    if (networkSelected !== '') {
      if (this.networkMultiSelectAction) {
        this.globalNetworkSelected = networkSelected.substring(0, networkSelected.length - 1);
        this.networkMultiSelectAction = false;
      }
    } else {
      this.globalNetworkSelected = '';
    }
  }
  e() {

    //this.router.navigate(['/BusinessRules']);
    // window.location.reload();
    //this.onSearch();

    let currentUrl = this.router.url;
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate([currentUrl]);

  }

  onReset() {
    this.spinnerService.show();
    this.showTable = false;
    this.commonCountryCompnent.reset()
  }

  selectedValues(event) {
    console.log(event);
    this.communityValue = sessionStorage.getItem('userCommunity');
    if (event) {
      if (event.vpmnCountry) {
        this.vpmnCountry = event.vpmnCountry;
      }
      if (event.vpmnNetwork) {
        this.vpmnNetwork = event.vpmnNetwork;
      }
    }
  }


  onSearch() {
    this.spinnerService.show();
    this.showTable = false;

    // if (this.vpmnCountry && this.vpmnNetwork) {
      if (this.vpmnCountry === 'All' && this.vpmnNetwork == 'All') {
        this.vpmnCountry = '';
        this.vpmnNetwork = '';
      }
      this.spinnerService.show();
      const apiUrl = this.endpointsService.URL_GET_BUSINESS_RULES +
        '&community=' + this.communityValue +
        '&vistingCountry=' + this.vpmnCountry +
        '&vistingNetwork=' + this.vpmnNetwork +
        '&userOrgId=' + sessionStorage.getItem('userOrgId');

      this.errorMessage = "";
      this.backendApiService.callToApi(apiUrl).subscribe(response => {
        // if (response === null || response === '' || response.length === 0) {
        //   this.showTable = false;
        //   this.errorMessage = "No Data Available";
        //   return;
        // }
        if ( response === '') {
          this.spinnerService.hide();
          return;
        }
        this.businessData = response;
        this.showTable = true;
        this.spinnerService.hide();
      });
    // }
  }


}
